import { SESSION_ALIAS_UUID_SHAPE_PATTERN } from "context/sessionAlias";

// A workflow reference written as one string. The API takes only the object; this module is the one
// place a client turns one into the other. docs/specs/2026-09-25-workflow-reference.md
const PARTS = ["org", "blob", "revision", "definition"];

const SHAPES = "definition, blob/revision/definition, or org/blob/revision/definition";

export function isIdShaped(value) {
  return "string" === typeof value && SESSION_ALIAS_UUID_SHAPE_PATTERN.test(value.trim().toLowerCase());
}

export function parseWorkflowPath(text) {
  const trimmed = "string" === typeof text ? text.trim() : "";
  if ( !trimmed ) {
    return { error: "Name a workflow definition." };
  }
  const parts = trimmed.split("/").map(part => part.trim());
  if ( parts.some(part => !part) ) {
    return { error: `A workflow path has an empty part — write it as ${SHAPES}.` };
  }
  if ( 1 === parts.length ) {
    return { reference: { definition: parts[0] } };
  }
  if ( 3 === parts.length ) {
    if ( !isIdShaped(parts[0]) ) {
      return {
        error: "A three-part workflow path starts with a blob ID — name a blob by its alias together with " +
          "its organization, as org/blob/revision/definition."
      };
    }
    return { reference: { blob: parts[0], revision: parts[1], definition: parts[2] } };
  }
  if ( 4 === parts.length ) {
    return { reference: { org: parts[0], blob: parts[1], revision: parts[2], definition: parts[3] } };
  }
  return { error: `A workflow path has one, three or four parts — ${SHAPES}.` };
}

export function formatWorkflowPath(reference) {
  if ( !reference ) {
    return "";
  }
  return PARTS.map(part => reference[part]).filter(Boolean).join("/");
}

export function formatWorkflowSource(reference) {
  if ( !reference ) {
    return null;
  }
  return PARTS.slice(0, 3).map(part => reference[part]).filter(Boolean).join("/") || null;
}

export function definitionAliasError(alias) {
  if ( "string" === typeof alias && SESSION_ALIAS_UUID_SHAPE_PATTERN.test(alias.trim()) ) {
    return "Alias can't be shaped like an id (8-4-4-4-12 hex digits) — a workflow reference would read it " +
      "as an id, so try a name instead, like \"triage\" or \"send-message\".";
  }
  return null;
}

export function createExecutionBody({ sessionId, workflow, inputData, tracing, description }) {
  const body = {
    command: "create_execution",
    target: { session: sessionId },
    workflow: workflow,
    input_data: inputData
  };
  if ( undefined !== tracing ) {
    body.tracing = tracing;
  }
  const text = ( description || "" ).trim();
  if ( text ) {
    body.description = text;
  }
  return body;
}
